// extracted by mini-css-extract-plugin
module.exports = {"container":"CountryCodeSelect_container__JU7Gl","scrollView":"CountryCodeSelect_scrollView__LlG3l","scrollView_min_height":"CountryCodeSelect_scrollView_min_height__W4oL3"};